import { Avatar, Container, Box, Typography } from '@mui/material'
import useInnovaAuth from 'components/common/hooks/useInnovaAuth'
import useInnovaTheme from 'components/common/hooks/useInnovaTheme'
import { userRoleSelector } from 'atoms'
import useOrgIcons from 'components/common/hooks/useOrgIcons'
import { useRecoilValue } from 'recoil'
import { appColors } from 'utils'

const UserProfileCard = () => {
  const { user } = useInnovaAuth()
  const { theme } = useInnovaTheme()
  const userRole = useRecoilValue(userRoleSelector)
  const { getCurrentOrgIcon } = useOrgIcons()

  const textColor = theme === 'dark' ? appColors.headerTextColor : '#151515'

  return (
    <Container>
      <Box sx={{ font: '1em roboto', fontWeight: 'bold', py: '8px', color: textColor }}>Account Settings</Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          color: textColor,
          pt: .5,
          pb: 1,
        }}>
        <Avatar
          sx={{
            width: 50,
            height: 50,
            backgroundColor: 'white',
            flexShrink: 0,
          }}
          alt='user'
          src={getCurrentOrgIcon()}
        />

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
          <Typography sx={{ fontSize: 15, fontWeight: 600 }}>{user?.name}</Typography>

          <Typography sx={{ fontSize: 13, opacity: 0.9 }}>Logged In • {userRole?.organization}</Typography>
        </Box>
      </Box>
    </Container>
  )
}

export default UserProfileCard
